import { useCallback } from 'react'
import { useT } from '@transifex/react'
import { ApiCustomerGroup } from '@vend/types'

const DEFAULT_GROUP_NAME = 'All Customers'

export const useTranslateCustomerGroup = () => {
  const t = useT()

  const translateCustomerGroup = useCallback(
    (group: ApiCustomerGroup) => {
      if (group.name === DEFAULT_GROUP_NAME) {
        return {
          ...group,
          name: t(DEFAULT_GROUP_NAME),
        }
      }
      return group
    },
    [t]
  )

  return translateCustomerGroup
}
